import React from 'react';
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Skeleton from '@material-ui/lab/esm/Skeleton';
import { Divider } from '@material-ui/core';

const UserInfoLoader = props => {
    const { classes } = props
    return (
        <Grid  item xs={12} md={6} lg ={6} >
            <Card className={classes.card}>
                <CardHeader
                    avatar={
                    <Avatar aria-label="recipe" className={classes.avatar}>
                        <Skeleton variant="circle" width={40} height={40} />
                    </Avatar>
                    }
                    action={
                    <IconButton aria-label="settings">
                        <MoreVertIcon />
                    </IconButton>
                    }
                    title={
                        <Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />
                    }
                    subheader={ 
                    <Skeleton height={10} width="40%" />
                    }
                />
                <Divider></Divider>
                <br></br>

                <br></br>
                    <Divider></Divider>
                <CardContent>
                        <div>
                            <CardHeader
                                avatar={
                                <Avatar aria-label="recipe" >
                                    <Skeleton variant="circle" width={40} height={40} />
                                </Avatar>
                                }
                                title={ <Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />}
                                subheader={  <Skeleton height={10} width="40%" />}
                            />
                            <CardHeader
                                avatar={
                                <Avatar aria-label="recipe" >
                                    <Skeleton variant="circle" width={40} height={40} />
                                </Avatar>
                                }
                                title={ <Skeleton height={10} width="80%" style={{ marginBottom: 6 }} />}
                                subheader={  <Skeleton height={10} width="40%" />}
                            />
                        </div>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default UserInfoLoader;